import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import { EditSubcategoryContext, IEditSubcategoryContext } from '../../../editSubcategoryState/editSubcategoryContext';
import React, { useContext, useMemo } from 'react';
import { InputFields } from './components/InputFields';
import style from './EditForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '18:13',
		optimalResolutions: {
			a: '324*234px',
			b: '648*468px',
		},
	},
	vertical: {
		ratio: '25:13',
		optimalResolutions: {
			a: '500*260px',
			b: '1000*520px',
		},
	},
};

export const EditForm: React.FC = () => {
	const { setFileId, deletePhoto, fileId, filePath, subcategoryID } =
		useContext<IEditSubcategoryContext>(EditSubcategoryContext);

	const loadFromFilePathOptions = useMemo(
		() => ({
			filePath,
			preSignedUrl: null,
			entityID: subcategoryID,
		}),
		[filePath, subcategoryID],
	);

	return (
		<div className={style.container} data-test="EditForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				deletePhotoHandler={deletePhoto}
				setFileId={setFileId}
				horizontalAspectRatio={324 / 234}
				verticalAspectRatio={500 / 260}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};
